import React, { useState, useEffect, useContext } from "react";
import { css } from "emotion";
import BillingTitle from "./BillingTitle";
import { boxStyles, colors, textSizes } from "../../styles/theme";
import CreditCardBar from "./CreditCardBar";
import workspaces from "../../services/api/workspaces";
import { GlobalContext } from "../../context/GlobalState";
import { BillingContext } from "../../context/BillingState";

const CardList = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [cardList, setCardList] = useState([]);
  const { currentWorkspace } = useContext(GlobalContext);
  const { getCardsFlag } = useContext(BillingContext);

  const toggleEdit = () => {
    setIsEditing(!isEditing);
  };

  const getCards = async () => {
    try {
      const { data } = await workspaces.paymentMethods(currentWorkspace);
      setCardList(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCards();
  }, [getCardsFlag]);

  return (
    <div className={container}>
      <div className="top-row">
        <BillingTitle title="Payment Methods" />
        {cardList.length > 0 &&
          <button type="button" className="edit" onClick={toggleEdit}>
            {isEditing ? "Done" : "Edit"}
          </button>
        }
      </div>
      {cardList.length > 0 ? (
      <div className="card-list">
        {cardList.map((paymentObj) => (
            <CreditCardBar
              paymentObj={paymentObj}
              key={paymentObj.id}
              isEditing={isEditing}
              isDefault={paymentObj.isDefault ? true : false}
            />
          ))}
      </div>
        ) : (
            <div className="empty-placeholder">
              <p>Your cards will show here when there is one added.</p>
            </div>
          )}
    </div>
  );
};

export default CardList;

const container = css`
  padding: ${boxStyles.standardPadding};
  .top-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .edit {
      background-color: transparent;
      border: none;
      color: ${colors.brandColor};
      font-size: ${textSizes.intermediate};
      cursor: pointer;
    }
  }

  .card-list {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 15px;
  }
  
  .empty-placeholder {
    border-radius: 8px;
    height: 77px;
    margin-top: 15px;
    background-color: ${colors.inputBackground};
    align-items: center;
    justify-content: center;
    display: flex;
    flex: 1;
    
    p {
      font-size: 14px;
      color: ${colors.subtitleColor};
    }
  }

  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    padding: ${boxStyles.desktopPadding} 0;
    
    .card-list,
    .top-row {
      width: 50%;
    }
  }
`;
